export const setColor = {
  mainWhite: '#ffffff',
  fontDark: '#3b4147',
  indigo: '#727cf5',
  mountainMeadow: '#1cc885',
  scooter: '#38afd1',
  shark: '#272c31',
  cloudy: '#b1b0ad',
  athensGray: '#e7e8ed',
  trout: '#4e555d',
  cadetBlue: '#aab8c5',
  outerSpace: '#2a313a',
  frenchRose: '#f15b79',
  limedSpruce: '#374049'
};
export const setRem = (number = 16) => {
  return `${number / 16}rem`;
};